<template>
  <div class="popup-zlatnik" :class="{popupactive: activePopup}">
      <div class="popup-inner">
          <i @click="closePopup" class="popup-close"></i>
          <h2 class="popup-title">
              Nagradno pitanje
          </h2>
          <p class="popup-p">
              Powered by McDonalds
          </p>
          <h6 class="popup-text">
              Ne propusti priliku osvojiti super nagrade koje ti je pripremio
          </h6>
          <i class="golden-token"></i>
          <a href="#" class="button-1 red"><span>kreni</span></a>
      </div>
  </div>
</template>

<script>

export default {
    name: 'popupzlatnik',
    data: function () {
        return {
            activePopup: false
        }
    },
    methods: {
        closePopup () {
            this.activePopup = false
        }
    }
}
</script>

<style lang="scss" scoped>
    .button-1 {
        padding: 11px 17px;
        span {
            padding: 0 30px;
        }
    }
</style>
